import { FC } from "react";
import { connectStateResults } from "react-instantsearch-dom";
import { StateResultsProvided } from "react-instantsearch-core";
import { LoadingDimmer } from "src/atoms/LoadingDimmer";

const StateResultsLoader: FC<StateResultsProvided> = ({ isSearchStalled }) => {
  return <LoadingDimmer loading={isSearchStalled as boolean} />;
};

const Loader = connectStateResults(StateResultsLoader);

export default Loader;
